export default __webpack_public_path__ + "static/media/slide-3.e29ce04d.svg";